export default "__VITE_ASSET__BrWvIhgT__"